<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/epigraph#epi">Epigraphs</a></p>
<p class="toc"><a href="#/xhtml/illustrations#ill">List of Illustrations</a></p>
<p class="toc-bot"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="toc"><a href="#/xhtml/part1#pt1">Part One: Elizabeth</a></p>
<p class="toc"><a href="#/xhtml/part2#pt2">Part Two: Duchess of York</a></p>
<p class="toc"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample">Part Three: Queen</span></p>
<p class="toc"><span href="#/xhtml/part4#pt4" title="Link target outside of Sample">Part Four: Queen Mother</span></p>
<p class="toc-bot"><span href="#/xhtml/photos1#pho1" title="Link target outside of Sample">Photographs</span></p>
<p class="toc"><span href="#/xhtml/tree#tree" title="Link target outside of Sample">Appendix: Family Trees</span></p>
<p class="toc"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by William Shawcross</span></p>
<p class="toc"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?28515b24